import { render, staticRenderFns } from "./MenuAnleitung.vue?vue&type=template&id=57dc79e6&scoped=true&"
import script from "./MenuAnleitung.vue?vue&type=script&lang=js&"
export * from "./MenuAnleitung.vue?vue&type=script&lang=js&"
import style0 from "./MenuAnleitung.vue?vue&type=style&index=0&id=57dc79e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc79e6",
  null
  
)

export default component.exports